import { render, staticRenderFns } from "./PatientSurvey.vue?vue&type=template&id=5c8cd3a2&scoped=true"
import script from "./PatientSurvey.vue?vue&type=script&lang=js"
export * from "./PatientSurvey.vue?vue&type=script&lang=js"
import style0 from "./PatientSurvey.vue?vue&type=style&index=0&id=5c8cd3a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8cd3a2",
  null
  
)

export default component.exports